import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainApi from "../../../../services/mainApi.service";
import { IAppointmentArrivals } from "../../../../models/appointment-arrival";

const APPOINTMENT_ARRIVAL_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/AppointmentArrivalRule/";
const appointmentArrivalService = new MainApi<IAppointmentArrivals>(
  APPOINTMENT_ARRIVAL_ROUTE,
);

const translationPath = "chatBot.page.service.appointmentArrivalRule.";

const AppointmentArrivalPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IAppointmentArrivals>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IAppointmentArrivals>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IAppointmentArrivals>
      showDefaultMacroFilters={false}
      service={appointmentArrivalService}
      columns={columns}
      title={t(translationPath + "appointment_arrivals")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_appointment_arrival") ||
        "Add Appointment Arrival Time"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default AppointmentArrivalPage;
